
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import { getAgentProductRecordList } from '@/api/order';
  import SkuListDialog from './components/sku-list-dialog.vue';

  @Component({
    name: 'agency-product-record',
    components: {
      PageFooter,
      SkuListDialog
    }
  })
  export default class AgencyProductRecord extends Vue {
    private id = +this.$route.query.id
    private list: any = [];
    private filterTime: any = [];
    private productNameKey = '';
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private currentId = 0;
    private isShowSku = false;

    mounted() {
      this.getList()
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }
    
    private clearSearch() {
      this.productNameKey = '';
      this.pageNo = 1;
      this.getList()
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private async getList() {
      let params: any = {
        check_user_id: this.id,
        page_no: this.pageNo,
        page_size: this.pageSize
      }
      if (this.productNameKey) {
        params.product_name = this.productNameKey
      }
      if (this.filterTime.length) {
        params.begin_time = this.filterTime[0] / 1000;
        params.end_time = this.filterTime[1] / 1000;
      }
      try {
        const res: any = await getAgentProductRecordList(params);
        this.list = res.info || [];
        this.total = res.count;
      } catch(e) {
        console.log(e)
      }
    }

    private showSkuList(id: number) {
      this.currentId = id;
      this.isShowSku = true;
    }
  }
